import { api } from './client';

export interface MigrationToken {
  id: string;
  organization_id: string;
  name: string;
  created_at: string;
  expires_at: string | null;
  revoked_at: string | null;
  last_used_at: string | null;
  source_config: string | null;
  token: string | null;  // Тільки при створенні
}

export interface MigrationTokenCreate {
  organization_id: string;
  name: string;
  expires_in_days?: number;
  source_config?: string | null;
}

export const migration = {
  listTokens: () =>
    api.get<MigrationToken[]>('/migration/tokens').then((r) => r.data),
  createToken: (p: MigrationTokenCreate) =>
    api.post<MigrationToken>('/migration/tokens', p).then((r) => r.data),
  revokeToken: (id: string) =>
    api.post(`/migration/tokens/${id}/revoke`).then(() => undefined),
};
